import {isValidQueryValue} from '../../../shared/utils/queryParams'

/** Serializes axios params without bracket array notation (Tomcat rejects sort[] in URLs). */
export function serializeProcurementQueryParams(params: Record<string, unknown>): string {
  const searchParams = new URLSearchParams()
  Object.entries(params).forEach(([key, value]) => {
    if (!isValidQueryValue(value)) return
    if (Array.isArray(value)) {
      value.forEach((entry) => {
        if (isValidQueryValue(entry)) {
          searchParams.append(key, String(entry).trim())
        }
      })
      return
    }
    searchParams.append(key, String(value).trim())
  })
  return searchParams.toString()
}
